module.exports = __webpack_public_path__ + "img/logo.788cb839.png";